// extracted by mini-css-extract-plugin
export default {"rotating":"loader_rotating__X8LVR","loading":"loader_loading__t8n5-"};